import { ComponentArrangementStyles, DefaultNodePlacer, DefaultTreeLayoutPortAssignment, EdgeRouter, EdgeRouterScope, LayoutOrientation, Mapper, RootAlignment, TreeLayout, TreeLayoutData, TreeLayoutPortAssignmentMode, TreeReductionStage } from "yfiles";
import HandleEdgesBetweenGroupsStage from "./handleEdgesBetweenGroupsStage";
import LayoutConfiguration from "./layoutConfiguration";
class TreeLayoutConfig extends LayoutConfiguration {
    createConfiguredLayout() {
        const layout = new TreeLayout();
        layout.parallelEdgeRouterEnabled = false;
        layout.subgraphLayoutEnabled = false;
        layout.layoutOrientation = LayoutOrientation.TOP_TO_BOTTOM;
        layout.componentLayout.style = ComponentArrangementStyles.MULTI_ROWS;
        layout.defaultNodePlacer = new DefaultNodePlacer({
            horizontalDistance: 20,
            verticalDistance: 40,
            rootAlignment: RootAlignment.CENTER,
            alignPorts: false,
            minimumLastSegmentLength: 10
        });
        layout.prependStage(this.createTreeReductionStage());
        layout.prependStage(new HandleEdgesBetweenGroupsStage(false, true, layout));
        layout.considerNodeLabels = false;
        layout.integratedEdgeLabeling = false;
        layout.labelingEnabled = false;
        layout.defaultPortAssignment = new DefaultTreeLayoutPortAssignment(TreeLayoutPortAssignmentMode.NONE);
        layout.groupingSupported = true;
        return layout;
    }
    createTreeReductionStage() {
        const reductionStage = new TreeReductionStage();
        const edgeRouter = new EdgeRouter();
        edgeRouter.rerouting = true;
        edgeRouter.scope = EdgeRouterScope.ROUTE_AFFECTED_EDGES;
        reductionStage.nonTreeEdgeRouter = edgeRouter;
        reductionStage.nonTreeEdgeSelectionKey = edgeRouter.affectedEdgesDpKey;
        return reductionStage;
    }
    createConfiguredLayoutData(graphComponent, _) {
        const { graph } = graphComponent;
        return new TreeLayoutData({
            gridNodePlacerRowIndices: node => {
                const predecessors = graph.predecessors(node);
                const parent = predecessors.at(0);
                if (parent) {
                    const siblings = graph.successors(parent).toArray();
                    return siblings.indexOf(node) % Math.round(Math.sqrt(siblings.length));
                }
                return 0;
            },
            leftRightNodePlacerLeftNodes: node => {
                const predecessors = graph.predecessors(node);
                const parent = predecessors.at(0);
                if (parent) {
                    const siblings = graph.successors(parent).toArray();
                    return siblings.indexOf(node) % 2 !== 0;
                }
                return false;
            },
            compactNodePlacerStrategyMementos: new Mapper(),
            assistantNodes: node => (node.tag ? node.tag.assistant : null)
        });
    }
}
export default TreeLayoutConfig;
